const types = {
	//Get Template name
	GET_SUBSCRIBER_START: "GET_SUBSCRIBER_START",
	GET_SUBSCRIBER_SUCCESS: "GET_SUBSCRIBER_SUCCESS",
	GET_SUBSCRIBER_ERROR: "GET_SUBSCRIBER_ERROR",
	GET_SUBSCRIBER_RESET: "GET_SUBSCRIBER_RESET",

	//Create Template name
	CREATE_SUBSCRIBER_START: "CREATE_SUBSCRIBER_START",
	CREATE_SUBSCRIBER_SUCCESS: "CREATE_SUBSCRIBER_SUCCESS",
	CREATE_SUBSCRIBER_ERROR: "CREATE_SUBSCRIBER_ERROR",
	CREATE_SUBSCRIBER_RESET: "CREATE_SUBSCRIBER_RESET",

	//delete Template name
	DELETE_SUBSCRIBER_START: "DELETE_SUBSCRIBER_START",
	DELETE_SUBSCRIBER_SUCCESS: "DELETE_SUBSCRIBER_SUCCESS",
	DELETE_SUBSCRIBER_ERROR: "DELETE_SUBSCRIBER_ERROR",
	DELETE_SUBSCRIBER_RESET: "DELETE_SUBSCRIBER_RESET",

	//update Template name
	UPDATE_SUBSCRIBER_START: "UPDATE_SUBSCRIBER_START",
	UPDATE_SUBSCRIBER_SUCCESS: "UPDATE_SUBSCRIBER_SUCCESS",
	UPDATE_SUBSCRIBER_ERROR: "UPDATE_SUBSCRIBER_ERROR",
	UPDATE_SUBSCRIBER_RESET: "UPDATE_SUBSCRIBER_RESET",

	//single item  name
	SINGLE_SUBSCRIBER_START: "SINGLE_SUBSCRIBER_START",
	SINGLE_SUBSCRIBER_SUCCESS: "SINGLE_SUBSCRIBER_SUCCESS",
	SINGLE_SUBSCRIBER_ERROR: "SINGLE_SUBSCRIBER_ERROR",
	SINGLE_SUBSCRIBER_RESET: "SINGLE_SUBSCRIBER_RESET",
};

export default types;
